/* El kanban: siete columnas en escritorio ("No le interesa" angosta y plegada), una por vez en
   celular con las fases como pastillas arriba. */
.filtros { display: flex; align-items: center; flex-wrap: wrap; gap: var(--s-4); }
.busqueda { width: 280px; }
.resto { display: contents; }
.botonFiltros { display: none; }

.fasesMovil { display: none; }

.tablero {
  display: grid;
  /* 170 hace entrar las siete columnas en 1440 con la barra lateral abierta; más angosto,
     el tablero se desplaza de costado. */
  grid-template-columns: repeat(7, minmax(170px, 1fr)) auto;
  gap: var(--s-4);
  align-items: stretch;
  overflow-x: auto;
  padding-bottom: var(--s-4);
}
.columna {
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
  min-height: 60vh;
  padding: var(--s-4);
  border-radius: var(--r-lg);
  background: var(--gray-100);
  transition: background var(--dur-fast) var(--ease-out), opacity var(--dur-fast) var(--ease-out);
}
.columna[data-destino="true"] { background: var(--accent-50); box-shadow: inset 0 0 0 1.5px var(--accent-300); }
.columna[data-apagada="true"] { opacity: 0.55; }
.columna[data-fase="no_interesa"] { background: var(--red-50); }
.columna[data-colapsada="true"] { padding: 0; width: 44px; border: 1px dashed var(--red-200); }

.cabecera {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  padding: var(--s-1) var(--s-2) var(--s-4);
  border-bottom: 3px solid var(--gray-300);
}
.columna[data-fase="respondio"] .cabecera, .columna[data-fase="info_enviada"] .cabecera, .columna[data-fase="seguimiento"] .cabecera { border-bottom-color: var(--accent-200); }
.columna[data-fase="pidio_mas"] .cabecera, .columna[data-fase="reunion"] .cabecera { border-bottom-color: var(--accent-500); }
.columna[data-fase="cliente"] .cabecera { border-bottom-color: var(--ink-900); }
.columna[data-fase="no_interesa"] .cabecera { border-bottom-color: var(--red-200); }
.titulo { flex: 1; min-width: 0; font-size: var(--fs-xs); font-weight: var(--fw-semibold); color: var(--text-strong); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.total { font-family: var(--font-mono); font-size: var(--fs-2xs); font-weight: var(--fw-semibold); color: var(--text-body); }

.colapsada {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--s-5);
  width: 100%;
  height: 100%;
  padding: var(--s-6) 0;
  border: 0;
  border-radius: inherit;
  background: none;
  cursor: pointer;
  color: var(--red-700);
}
.colapsada .total { color: var(--red-700); }
.vertical { writing-mode: vertical-rl; font-size: var(--fs-xs); font-weight: var(--fw-semibold); white-space: nowrap; }

.soltar {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 0 var(--s-5);
  border: 1.5px dashed var(--accent-500);
  border-radius: var(--r-md);
  background: var(--surface-card);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  color: var(--accent-700);
  text-align: center;
}
.vacia { margin: 0; padding: var(--s-5) var(--s-2); font-size: var(--fs-2xs); line-height: 18px; color: var(--text-muted); }

.tarjeta {
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
  padding: var(--s-5);
  border-radius: 10px;
  background: var(--surface-card);
  border: 1px solid var(--border-hair);
  cursor: pointer;
  text-align: left;
  transition: border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out);
}
.tarjeta:hover { border-color: var(--gray-300); }
.tarjeta:focus-visible { outline: 2px solid var(--accent-500); outline-offset: 2px; }
.tarjeta[draggable="true"] { cursor: grab; }
.tarjeta[data-nueva="true"], .tarjeta[data-seleccionada="true"] { border-color: var(--accent-500); box-shadow: 0 0 0 3px var(--accent-50); }
.tarjeta[data-accion="true"] { box-shadow: inset 3px 0 0 var(--amber-600); }
.tarjeta[data-seleccionada="true"][data-accion="true"] { box-shadow: inset 3px 0 0 var(--amber-600), 0 0 0 3px var(--accent-50); }
.tarjeta[data-arrastrando="true"] { opacity: 0.4; }

.nombre { display: flex; align-items: flex-start; justify-content: space-between; gap: var(--s-3); font-size: var(--fs-sm); font-weight: var(--fw-semibold); line-height: 18px; color: var(--text-strong); }
.punto { flex-shrink: 0; width: 8px; height: 8px; margin-top: 5px; border-radius: var(--r-full); background: var(--accent-500); }
.cita { margin: 0; padding-left: var(--s-4); border-left: 2px solid var(--accent-200); font-size: var(--fs-xs); line-height: 18px; color: var(--text-body); display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
.linea { font-size: var(--fs-2xs); line-height: 16px; color: var(--text-muted); overflow-wrap: anywhere; }
.plantilla { align-self: flex-start; max-width: 100%; padding: 2px 6px; border-radius: var(--r-xs); background: var(--gray-50); font-family: var(--font-mono); font-size: var(--fs-3xs); color: var(--text-body); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.fecha { align-self: flex-start; padding: var(--s-2) var(--s-4); border-radius: var(--r-sm); background: var(--accent-50); font-size: var(--fs-2xs); font-weight: var(--fw-semibold); color: var(--accent-700); }
.cash { font-family: var(--font-display); font-size: var(--fs-lg); font-weight: var(--fw-semibold); color: var(--text-strong); }

.demo { align-self: flex-start; padding: var(--s-2) var(--s-4); border-radius: var(--r-sm); background: var(--green-50); font-size: var(--fs-2xs); font-weight: var(--fw-semibold); color: var(--green-700); }
.demoLista { align-self: flex-start; padding: var(--s-2) var(--s-4); border-radius: var(--r-sm); background: var(--accent-50); font-size: var(--fs-2xs); font-weight: var(--fw-semibold); color: var(--accent-700); }
.pie { display: flex; align-items: center; justify-content: space-between; gap: var(--s-3); }
.cuando { font-size: var(--fs-2xs); color: var(--text-muted); white-space: nowrap; }
.alerta { font-size: var(--fs-2xs); font-weight: var(--fw-semibold); color: var(--amber-700); }
.pie .alerta { white-space: nowrap; }
.responsable { flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: var(--r-full); background: var(--accent-100); font-size: 9px; font-weight: 700; color: var(--accent-700); }

.acciones, .botones { display: flex; align-items: center; gap: var(--s-3); }
.botones > * { flex: 1; }
.rapida { flex: 1; min-width: 0; justify-content: center; }
.soloMovil { display: none; }

@media (max-width: 800px) {
  .busqueda { flex: 1; width: auto; min-width: 0; }
  .botonFiltros { display: inline-flex; }
  .resto { display: none; }
  .filtros[data-abiertos="true"] .resto { display: flex; flex-wrap: wrap; gap: var(--s-4); width: 100%; }

  .fasesMovil { display: flex; gap: var(--s-3); overflow-x: auto; margin: 0 calc(var(--s-6) * -1); padding: 0 var(--s-6) var(--s-2); scrollbar-width: none; }
  .fasesMovil > * { flex-shrink: 0; }

  .tablero { display: block; overflow: visible; }
  .columna { min-height: 0; padding: 0; background: none; gap: var(--s-5); }
  .columna[data-activa="false"] { display: none; }
  .columna[data-fase="no_interesa"] { background: none; }
  .cabecera { display: none; }
  .tarjeta { padding: var(--s-6); gap: var(--s-5); border-radius: var(--r-lg); }
  .tarjeta[draggable="true"] { cursor: pointer; }
  .nombre { font-size: var(--fs-md); }
  .cita { font-size: var(--fs-sm); line-height: 20px; }
  .soloMovil { display: flex; }
  .acciones :global(button) { min-height: 40px; }
}
